import React, { FunctionComponent, memo, useState } from 'react';

import ContentMedia from 'components/ContentMedia/ContentMedia';
import RichText from 'components/RichText/RichText';
import VideoBlock from 'components/VideoBlock/VideoBlock';
import { ROUTES } from 'utils/routes';

import { CarouselSlidesProps } from '../Carousel';

import * as S from './CarouselSlide.styles';

export interface CarouselSlideProps extends CarouselSlidesProps {
  hideCaseStudyButton?: boolean;
}

const defaultProps: Partial<CarouselSlideProps> = {};

const CarouselSlide: FunctionComponent<CarouselSlideProps> = ({
  media,
  mediaType,
  question,
  clientName,
  caseStudy,
  buttonText,
  videoErrorMessage,
  hideCaseStudyButton,
  source,
  sourceId,
  azureUserId,
  azurePlaceholder,
  autoplay,
  manualPlay,
  mute,
  withSound,
  vimeoBackground,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <S.ImageWrapper>
        {source === 'azure' || source === 'vimeo' ? (
          <VideoBlock
            videoSource={source}
            videoSourceId={sourceId}
            azureUserId={azureUserId}
            autoplay={autoplay}
            manualPlay={manualPlay}
            mute={mute}
            withSound={withSound}
            azurePlaceholder={azurePlaceholder}
            vimeoBackground={vimeoBackground}
          />
        ) : (
          <ContentMedia
            media={media}
            mediaType={mediaType}
            videoErrorMessage={videoErrorMessage}
            autoplay={autoplay}
            mute={mute}
          />
        )}
      </S.ImageWrapper>

      <S.SlideOverlay
        onMouseLeave={() => setHovered(false)}
        onMouseEnter={() => setHovered(true)}
      >
        <S.Container>
          {question && (
            <S.Question>
              <RichText
                as="h1"
                size="heading1"
                richText={question}
                defaultFormatting
              />
            </S.Question>
          )}

          <S.CaseStudyWrapper>
            <S.CarouselTextWrapper fixCorner={!question}>
              <RichText
                as="h4"
                size="heading4"
                richText={clientName}
                defaultFormatting
              />
            </S.CarouselTextWrapper>
            {(hovered || !hideCaseStudyButton) && buttonText && (
              <S.CarouselButton
                label={buttonText}
                href={ROUTES.WORK + '/' + caseStudy?.slug}
                transparent
                fixBottom={!question}
              />
            )}
          </S.CaseStudyWrapper>
        </S.Container>
      </S.SlideOverlay>
    </>
  );
};

CarouselSlide.defaultProps = defaultProps;

export default memo(CarouselSlide);
